import { AxiosInstance } from 'axios';

import { insertId } from '../insertId';
import { toResponse } from '../genericToResponse';
import { cancellable } from '../cancellable';

export default (api: AxiosInstance, url: string) => (linkId: number) => {
  const urlWithId = insertId(url, linkId);
  return cancellable<any>(
    (cancelOptions: any) => api.post(urlWithId, cancelOptions),
    toResponse
  );
};



// WEBPACK FOOTER //
// ./src/services/api/links/archiveLink.ts